/** 业务成功状态码 */
export const API_SUCCESS_CODE = '0';

/** 原网关静默成功码（ai-gateway-portal ErrorShowType.SILENT） */
export const GATEWAY_SUCCESS_CODE = '200';

/** 未登录 / 无权限（统一按访问受限处理） */
export const API_ERROR_CODE_UNAUTHORIZED = '40401';

/** 请求频率限制 */
export const API_ERROR_CODE_RATE_LIMIT = '40429';

/** 服务异常 */
export const API_ERROR_CODE_SERVER_ERROR = '50000';

/** 通用业务响应结构 */
export interface ApiResponse<T = unknown> {
  code: string;
  message: string;
  data: T;
}

export interface ApiPageParams {
  pageNo?: number;
  pageSize?: number;
}

export interface ApiSortItem {
  field: string;
  order: 'asc' | 'desc';
}

export interface ApiPageRequest {
  page?: ApiPageParams;
  sorts?: ApiSortItem[];
}

/** 接口通用操作人信息 */
export interface OperatorUser {
  displayName?: string;
  email?: string;
  status?: string;
  userId?: string;
  username?: string;
}

/** 分页接口 data 固定结构 */
export interface ApiPageResult<T> {
  list: T[];
  total: number;
  totalPage: number;
  pageNo: number;
  pageSize: number;
}

export const normalizeApiCode = (code: unknown) => String(code);

export const isApiSuccessCode = (code: unknown) =>
  normalizeApiCode(code) === API_SUCCESS_CODE;

/**
 * 原网关业务成功判定：
 * - data 有值视为成功
 * - 或 code 为 200 / 0（兼容无 data 的写操作）
 */
export const isGatewayBizSuccess = (body: ApiResponse) => {
  if (body.data != null && body.data !== '') {
    return true;
  }
  const code = normalizeApiCode(body.code);
  return code === GATEWAY_SUCCESS_CODE || code === API_SUCCESS_CODE;
};

export const isApiResponse = (body: unknown): body is ApiResponse => {
  return (
    typeof body === 'object' &&
    body !== null &&
    'code' in body &&
    'message' in body &&
    normalizeApiCode((body as ApiResponse).code) !== 'undefined'
  );
};

export const isApiSuccess = (body: ApiResponse) => isApiSuccessCode(body.code);
